import { Buffer } from 'buffer';

//const AD_API_ENDPOINT = "http://dev-sqlserver19.i-docs.local:9090/adapi"; // HTTP Endpoint where AD Management API is installed on dev-sqlserver19
const AD_API_ENDPOINT = process.env.REACT_APP_AD_API_ENDPOINT || "https://teampass.i-docs.com/adapi"; // HTTPS Endpoint provided by NGINX configuration on hephaestus
const AD_API_USER = process.env.REACT_APP_AD_API_USER;
const AD_API_PASSWORD = process.env.REACT_APP_AD_API_PASSWORD;

async function apicall(method, body) {
  //let authHeader = btoa(`${AD_API_USER}:${AD_API_PASSWORD}`);
  let authHeader = Buffer.from(`${AD_API_USER}:${AD_API_PASSWORD}`).toString('base64');
  
  let apiMethod = method;
  let requestBody = body;

  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Basic ${authHeader}`);

  const requestOptions = {
    method: "POST",
    headers: headers,
    body: requestBody,
  };

  try {
    const response = await fetch(
      `${AD_API_ENDPOINT}/${apiMethod}`,
      requestOptions
    );

    const responseBody = await response?.json();
    if (responseBody?.hasError === false && responseBody?.result === "Ok") {
      //console.log(responseBody);
      return true;
    } else {
      console.error("Response error:", responseBody);
      return false;
    }
  } catch (error) {
    console.error("Fetch error:", error);
    return false;
  }
}

async function unlockUser(user) {
  const body = JSON.stringify({
    identity: user,
  });

  return await apicall("unlock_account", body);
}

async function resetUserPassword(user, newPassword) {
  const body = JSON.stringify({
    identity: user,
    newPassword: newPassword,
  });

  return await apicall("reset_password", body);
}

async function changeUserPassword(user, oldPassword, newPassword) {
  const body = JSON.stringify({
    identity: user,
    oldPassword: oldPassword,
    newPassword: newPassword,
  });

  return await apicall("change_password", body);
}

export { unlockUser, resetUserPassword, changeUserPassword };

//Quokka Tests
//unlockUser("g.papadakis").then((result) => console.log(result));
//resetUserPassword("g.rodopoulos", "grrd24!@#").then((result) => console.log(result));;
//changeUserPassword("g.rodopoulos", "grrd24!@#", "grrd24!@#").then((result) => console.log(result));
